import { render, staticRenderFns } from "./OSectionHeader.vue?vue&type=template&id=6a3b5d0e&"
import script from "./OSectionHeader.vue?vue&type=script&lang=js&"
export * from "./OSectionHeader.vue?vue&type=script&lang=js&"
import style0 from "./OSectionHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports